module.exports = __webpack_public_path__ + "static/media/presentation6.c951657e.png";